import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

const FAQAccordion = ({ items }) => {
  const [open, setOpen] = useState(0);

  return (
    <div className="divide-y divide-white/10 rounded-2xl border border-foreground/10 bg-foreground/[0.02]" data-testid="faq-accordion">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="px-6 md:px-8">
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 py-5 md:py-6 text-left"
              aria-expanded={isOpen}
              aria-controls={`faq-panel-${i}`}
              data-testid={`faq-toggle-${i}`}
            >
              <span className="font-display text-base md:text-lg">{item.q}</span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-foreground/15 transition ${
                  isOpen ? "rotate-180 bg-foreground/5" : ""
                }`}
              >
                {isOpen ? <Minus className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.28, ease: [0.2, 0.7, 0.2, 1] }}
                  className="overflow-hidden"
                  id={`faq-panel-${i}`}
                  role="region"
                >
                  <p className="pb-6 md:pb-7 text-sm md:text-[15px] text-muted-foreground leading-relaxed">
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
